module.exports = __webpack_public_path__ + "media/images/workflow-remove-bad1f68af786da1e2991565853f3f5c1.svg";